import { useCallback } from 'react';

// The sentence a request rejects with when psy could not be reached at all:
// the network is down, or the gateway could not reach the service behind it,
// as while a service restarts. Every screen translates it like any other
// refusal, so a failure never shows a parser's error or Caddy's "Bad Gateway".
export const unreachable = 'psy could not be reached. Check your connection and try again';

// What Caddy answers, in the shared envelope, when the service behind it did
// not answer: bad gateway, unavailable and gateway timeout.
const gateway = [ 502, 503, 504 ];

// Settles a fetch of one of psy's services with the `data` of the shared
// envelope. A refusal rejects with an Error carrying the service's own
// sentence, so the screen can put it under the field; a request that never
// reached the service rejects with the unreachable sentence. useRequest and
// useGraphql both read their answers through it.
export function settle(fetching) {
  return fetching.then(function(response) {
    if (gateway.includes(response.status) === true) {
      throw new Error(unreachable);
    }

    return response.json();
  }).catch(function() {
    throw new Error(unreachable);
  }).then(function({ data, errors }) {
    if (errors != null) {
      throw new Error(errors[ 0 ].message);
    }

    return data;
  });
}

// Calls one of psy's HTTP services through Caddy.
//
// Same-origin, so the session cookie travels without asking for it.
export function useRequest() {
  return useCallback(function({ path, method, body }) {
    return settle(fetch(path, {
      method,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }));
  }, []);
}
